module.exports = __webpack_public_path__ + "img/quiz-03.45bb5a9e.jpg";